import { Injectable } from "@angular/core";

@Injectable()
export class LocalStorageService {
  // private storageData = {};

  constructor() {
    /*Store all data from local storage to service*/
    // const keys = Object.keys(localStorage);
    // let i = keys.length;
    // while (i--) {
    //   this.storageData[keys[i]] = localStorage.getItem(keys[i]);
    // }
  }

  setItem(key, value) {
    // this.storageData[key] = JSON.stringify(value);
    localStorage.setItem(key, JSON.stringify(value));
  }

  getItem(key) {
    return localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : "";
    // return this.storageData[key] ? JSON.parse(this.storageData[key]) : "";
  }

  removeItem(key) {
    // delete this.storageData[key];
    localStorage.removeItem(key);
  }

  clear() {
    // this.storageData = {};
    localStorage.clear();
  }
}
